import type { TimeZonePreference } from '@studio/api-custom-attributes';

export const DEFAULT_TIME_ZONE = 'UTC';

export const { timeZone: LOCAL_TIME_ZONE } =
  new Intl.DateTimeFormat().resolvedOptions();

export function resolveTimeZonePreference(
  timeZonePreference: TimeZonePreference,
  realmTimeZone: string,
): string {
  const timeZonePreferenceType = timeZonePreference.type;
  switch (timeZonePreferenceType) {
    case 'realm':
      return realmTimeZone;
    case 'custom':
      return timeZonePreference.timeZone;
    case 'local':
      return LOCAL_TIME_ZONE;
    default:
      timeZonePreferenceType satisfies never;
      throw new Error(
        `Invalid time zone preference: ${timeZonePreferenceType}`,
      );
  }
}
